module.exports = __webpack_public_path__ + "media/images/bg/hero/brodno-pricing-dba5fc18b5549b4452e5dc28829db7b0.jpg";